// extracted by mini-css-extract-plugin
export var checkbox = "_9q-0";
export var circle = "_9q-3";
export var horizontalContainer = "_9q-7";
export var sm = "_9q-5";
export var switch0 = "_9q-2";
export var switchDisabled = "_9q-8";
export var switchEnabled = "_9q-1";
export var textSwitchContainer = "_9q-9";
export var textSwitchOption = "_9q-a";
export var textSwitchOptionSelected = "_9q-b";
export var verticalContainer = "_9q-6";
export var xs = "_9q-4";